import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import Header from "../HeaderComponent/Header";
import history from "../../auth/history";
import './TransactionList.css';
import FooterComponet from "../FooterComponent/FooterComponet";
import OrderDetails from './../MoneyTransferComponent/OrderDetails';
import TransferDetails from "../MoneyTransferComponent/TransferDetails";
import SubTransactionTxn from "../MoneyTransferComponent/SubTransactionTxn";
import moment from "moment";
import { CSVLink } from "react-csv";
import BankLogo from "../../assests/images/bank-logo.png";
import FinxPayLogo from "../../assests/images/finxpay.png";

import Pagination from "react-js-pagination";
import { store } from "../../redux/store";
import { setTxnHistoryElementNo, setTxnHistoryResponse, setTxnReportingData, setTxnHistoryPaginationResponse, selectedSender, selectedBeneList, setBeneMoneyTransfer, setSendersListDetails } from './../../redux/misc-data/misc-data.action';
import HeaderCommon from './../HeaderComponent/HeadeCommon';
import ContentLoader from 'react-content-loader';
import Menu from "../MenuComponent/Menu";
import { Link } from "react-router-dom";

const httpClient = axios.create();




class TransactionHistory extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			password: '',
			otpRef: '',
			message: '',
			loading: false,
			txnData: '',
			showModal: false,

			beneName: '',
			beneAccount: '',
			bankName: '',
			beneifscCode: '',
			senderName: '',
			transferredAmount: '',
			surcharge: '',
			totalAmount: '',

			orderId: '',
			createdOn: '',

			paymentStatus: '',
			searchTxn: '',
			formDate: '',
			toDate: '',

			activePage: 1,

			statusList: [
				{ value: "Select", label: "Select" },
				{ value: "Success", label: "Success" },
				{ value: "Failed", label: "Failed" },
				{ value: "Pending", label: "Pending" },
				{ value: "Processing", label: "Processing" },
				{ value: "Init", label: "Init" }
			],
			selectedStatus: '',
			applyFiler: false,
			errorMessage: '',
			enteredTxn: '',
			contentLoading: false,
			txnSubOrder: ''
		}
	}



	enterTxn = (event) => {
		event.preventDefault();
		this.setState({
			enteredTxn: event.target.value.toLowerCase()
		})
	}

	searchTxn = (event) => {

		event.preventDefault();
		if (this.state.enteredTxn.length > 0) {

			var txnSearchurl = '/api/v1/dmt/order/search/' + this.state.enteredTxn.toLowerCase() + '/' + this.props.agentInfo.id;


			const headers = {
				'Authorization': 'Bearer ' + this.props.token,
				'client-id': this.props.agentInfo.id,
				'role': this.props.clientRole
			}

			this.setState({ activePage: 1 });

			httpClient.get(txnSearchurl, { headers }
			).then((response) => {

				console.log('txn search response' + JSON.stringify(response.data));
				if (response.data.response.msg == 'SUCCESS') {
					console.log('txn search success response....' + response.data);
					store.dispatch(setTxnHistoryResponse(response.data.list));
					store.dispatch(setTxnHistoryPaginationResponse(response.data.list.slice(0, 20)));
					store.dispatch(setTxnHistoryElementNo(response.data.totalElements));

				} else {
					this.errorMessageCall(response.data.response.displayMsg);
					store.dispatch(setTxnHistoryElementNo(0));
					console.log('txn search failure response....' + response.data);
				}
			}).catch(error => {

			});
		}




	}

	handlePageChangeDefault(pageNumber) {

		store.dispatch(setTxnReportingData(''));
		store.dispatch(setTxnHistoryResponse(''));
		store.dispatch(setTxnHistoryPaginationResponse(''));
		store.dispatch(setTxnHistoryElementNo(0));

		this.setState({
			contentLoading: true,
			errorMessage: ''
		})
		var pageNo = pageNumber;
		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}


		this.setState({ activePage: pageNo });

		var url = '';
		if (this.props.formDate != '' && this.props.toDate != ''
			&&
			this.state.applyFiler == 'true'
		) {
			var page = pageNo-1;
			url = '/api/v1/dmt/order/history' + '/' + this.props.agentInfo.id + '/' +
				moment(this.props.formDate).format('YYYY-MM-DD') + '/' +
				moment(this.props.toDate).format('YYYY-MM-DD') + '/' + page;
		} else {
			var page = pageNo-1;
			url = '/api/v1/dmt/order/history' + '/' + this.props.agentInfo.id + '/' + page;
		}


		httpClient.get(url, { headers }
			).then((response) => {

				this.setState({
					contentLoading: false
				})
				this.setState({
					totalPages: response.data.totalPages,
					totalElements: response.data.totalElements
				})

				var orderedListByCreationTime = response.data.list;
				orderedListByCreationTime.sort(({ createdOn: a }, { createdOn: b }) => a > b ? 1 : a < b ? -1 : 0).reverse();
				response.data.list = orderedListByCreationTime;


				if (response.data.response.msg == 'SUCCESS') {

					console.log('transaction history successresponse....' + JSON.stringify(response.data.list));

					var txnHistoryFilteredList = [];

					if (this.state.selectedStatus != '') {
						response.data.list.map(txnResp => {
							if (txnResp.status.toUpperCase() == this.state.selectedStatus.toUpperCase()) {
								txnHistoryFilteredList.push(txnResp);
							}
						})

					}
					console.log('txnHistoryFilteredList...' + JSON.stringify(txnHistoryFilteredList));
					if (this.state.selectedStatus != '') {
						store.dispatch(setTxnHistoryResponse(txnHistoryFilteredList));
						store.dispatch(setTxnHistoryElementNo(txnHistoryFilteredList.length));
						store.dispatch(setTxnHistoryPaginationResponse(txnHistoryFilteredList));
					} else {
						store.dispatch(setTxnHistoryResponse(response.data.list));
						store.dispatch(setTxnHistoryPaginationResponse(response.data.list.slice(0, 20)));
						store.dispatch(setTxnHistoryElementNo(response.data.totalElements));
					}
					this.txnHistory();
				} else {
					this.setState({
						contentLoading: false,
						errorMessage: 'Something went wrong'
					})
					console.log('transaction history failure response....' + response.data);

				}
			}).catch(error => {

				this.setState({
					contentLoading: false,
					errorMessage: 'Something went wrong!'
				})
				// if (error.message.includes("401")) {
				// 	tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
				// } else {

				// }
			});
		
	}


	// handlePageChangeDefault(pageNumber) {

	// 	store.dispatch(setTxnReportingData(''));
	// 	store.dispatch(setTxnHistoryResponse(''));
	// 	store.dispatch(setTxnHistoryPaginationResponse(''));
	// 	store.dispatch(setTxnHistoryElementNo(0));

	// 	this.setState({
	// 		contentLoading: true
	// 	})
	// 	var pageNo = pageNumber;
	// 	const headers = {
	// 		'Authorization': 'Bearer ' + this.props.token,
	// 		'client-id': this.props.agentInfo.id,
	// 		'role': this.props.clientRole
	// 	}


	// 	this.setState({ activePage: pageNo });

	// 	var url = '';
	// 	if (this.state.formDate != '' && this.state.toDate != ''
	// 		&&
	// 		this.state.applyFiler == 'true'
	// 	) {
	// 		var page = parseInt((pageNo - 1) / 3);
	// 		url = '/api/v1/dmt/order/history' + '/' + this.props.agentInfo.id + '/' + this.state.formDate + '/' + this.state.toDate + '/' + page;
	// 	} else {
	// 		var page = parseInt((pageNo - 1) / 3);
	// 		url = '/api/v1/dmt/order/history' + '/' + this.props.agentInfo.id + '/' + page;
	// 	}

	// 	if (pageNo % 3 == 1) {
	// 		console.log('calling next set of data');

	// 		httpClient.get(url, { headers }
	// 		).then((response) => {

	// 			this.setState({
	// 				contentLoading: false
	// 			})

	// 			if (response.data.response.msg == 'SUCCESS') {

	// 				console.log('transaction history successresponse....' + JSON.stringify(response.data.list));

	// 				var txnHistoryFilteredList = [];

	// 				if (this.state.selectedStatus != '') {
	// 					response.data.list.map(txnResp => {
	// 						if (txnResp.status.toUpperCase() == this.state.selectedStatus.toUpperCase()) {
	// 							txnHistoryFilteredList.push(txnResp);
	// 						}
	// 					})

	// 				}
	// 				console.log('txnHistoryFilteredList...' + JSON.stringify(txnHistoryFilteredList));
	// 				if (this.state.selectedStatus != '') {
	// 					store.dispatch(setTxnHistoryResponse(txnHistoryFilteredList));
	// 					store.dispatch(setTxnHistoryElementNo(txnHistoryFilteredList.length));
	// 					store.dispatch(setTxnHistoryPaginationResponse(txnHistoryFilteredList));
	// 				} else {
	// 					store.dispatch(setTxnHistoryResponse(response.data.list));
	// 					store.dispatch(setTxnHistoryPaginationResponse(response.data.list.slice(0, 10)));
	// 					store.dispatch(setTxnHistoryElementNo(response.data.totalElements));
	// 				}

	// 			} else {
	// 				console.log('transaction history failure response....' + response.data);

	// 			}
	// 		}).catch(error => {

	// 			this.setState({
	// 				contentLoading: false
	// 			})

	// 		});

	// 	} else {
	// 		var startPageNo = 0;
	// 		var endPageNo = 0;
	// 		if (pageNo % 3 > 0) {
	// 			startPageNo = pageNo % 3 - 1;
	// 			endPageNo = startPageNo + 1;
	// 		} else {
	// 			startPageNo = pageNo % 3 + 2;
	// 			endPageNo = startPageNo + 1;
	// 		}

	// 		// alert('startPageNo endpageNo'+startPageNo+' '+endPageNo);	
	// 		httpClient.get(url, { headers }
	// 		).then((response) => {

	// 			this.setState({
	// 				contentLoading: false
	// 			})

	// 			if (response.data.response.msg == 'SUCCESS') {

	// 				console.log('transaction history successresponse....' + JSON.stringify(response.data.list));


	// 				var txnHistoryFilteredList = [];

	// 				if (this.state.selectedStatus != '') {

	// 					response.data.list.map(txnResp => {
	// 						if (txnResp.status.toUpperCase() == this.state.selectedStatus.toUpperCase()) {
	// 							txnHistoryFilteredList.push(txnResp);
	// 						}
	// 					})
	// 					store.dispatch(setTxnHistoryResponse(txnHistoryFilteredList));
	// 					store.dispatch(setTxnHistoryElementNo(txnHistoryFilteredList.length));
	// 					console.log('fetching from already picked up data of total length...' + txnHistoryFilteredList.length +
	// 						'....' + startPageNo * 10 + '...' + endPageNo * 10);
	// 					var tresponse2 = txnHistoryFilteredList.slice(startPageNo * 10, endPageNo * 10);
	// 					store.dispatch(setTxnHistoryPaginationResponse(tresponse2));

	// 				} else {


	// 					store.dispatch(setTxnHistoryResponse(response.data.list));
	// 					store.dispatch(setTxnHistoryElementNo(response.data.totalElements));

	// 					console.log('fetching from already picked up data of total length...' + this.props.txnHistoryResponse.length +
	// 						'....' + startPageNo * 10 + '...' + endPageNo * 10);
	// 					var tresponse2 = response.data.list.slice(startPageNo * 10, endPageNo * 10);
	// 					store.dispatch(setTxnHistoryPaginationResponse(tresponse2));
	// 				}


	// 			} else {
	// 				console.log('transaction history failure response....' + response.data);

	// 			}
	// 		}).catch(error => {

	// 			this.setState({
	// 				contentLoading: false
	// 			})
	// 		});





	// 	}


	// }

	moDalPrint = (event, txn) => {
		event.preventDefault();

		this.setState({
			showModal: true,
			paymentStatus: txn.status != null ? txn.status : 'Unknown Status',
			beneName: txn.beneficiary.name != null ? txn.beneficiary.name : 'Unknown Benefisciary',
			beneAccount: txn.beneficiary.account != null && txn.beneficiary.account.accNum,
			bankName: txn.beneficiary.account != null && txn.beneficiary.account.bank,
			beneifscCode: txn.beneficiary.account != null && txn.beneficiary.account.ifsc,
			senderName: txn.customer.name != null ? txn.customer.name : 'Unknown Sender',
			transferredAmount: txn.transaction != null && txn.transaction.amount,
			surcharge: txn.origTxn != null ? parseFloat(txn.origTxn.surcharge).toFixed(2) : '0.00',
			totalAmount: parseFloat(txn.origTxn != null ? parseFloat(txn.origTxn.amount).toFixed() : '0.00') +
				parseFloat(txn.origTxn != null ? txn.origTxn.surcharge : '0.00'),
			orderId: txn.id != null ? txn.id : 'Unlnown Id',
			createdOn: moment(txn.createdOn).format('DD-MM-YYYY hh:mm:ss'),
			txnSubOrder: txn.subOrders != null ? txn.subOrders : ''
		})
	}


	componentDidMount = () => {
		store.dispatch(setTxnHistoryElementNo(''));
		this.loadReset();
	}

	loadReset = () => {

		this.setState({
			contentLoading: true
		})

		store.dispatch(setTxnReportingData(''));
		store.dispatch(setTxnHistoryResponse(''));
		store.dispatch(setTxnHistoryPaginationResponse(''));
		store.dispatch(setTxnHistoryElementNo(0));

		var d = new Date();
		d.setDate(d.getDate() - 2);
		var fromDate = d.toISOString().slice(0, 10);
		var d1 = new Date();
		d1.setDate(d1.getDate() + 1);
		var toDate = d1.toISOString().slice(0, 10);
		console.log('to date..' + toDate);
		console.log('start date' + fromDate);

		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}


		var url = '/api/v1/dmt/order/history' + '/' + this.props.agentInfo.id + '/' + 0;


		httpClient.get(url, { headers }
		).then((response) => {

			this.setState({
				contentLoading: false
			})

			if (response.data.response.msg == 'SUCCESS') {
				console.log('transaction history successresponse....' + response.data.list);

				store.dispatch(setTxnHistoryResponse(response.data.list));
				store.dispatch(setTxnHistoryElementNo(response.data.totalElements));
				store.dispatch(setTxnHistoryPaginationResponse(response.data.list));


			} else {
				this.errorMessageCall(response.data.response.displayMsg)
				console.log('transaction history failure response....' + response.data);

			}
		}).catch(error => {
			this.setState({
				contentLoading: false
			})
			this.errorMessageCall(error.message)

		});

	}



	txnHistory = () => {
		store.dispatch(setTxnReportingData(''));

		var OrderId = '';
		var OrderCreatedOn = '';
		var SenderMobile = '';
		var BeneficiaryBankName = '';
		var BeneficiaryBranchName = '';
		var BeneficiaryAccountNo = '';
		var BeneficiaryIFSC = '';
		var orderList = [];
		var orderList1 = [];
		var rowList = [];

		this.props.txnPaginationResponse.map(res => {

			OrderId = res.id == null ? '' : res.id;
			OrderCreatedOn = res.createdOn == null ? '' : moment(res.createdOn).format('DD-MM-YYYY hh:mm:ss')
			SenderMobile = (res.customer != null && res.customer.mobile != null) ? res.customer.mobile : '';
			BeneficiaryBankName = (res.beneficiary != null && res.beneficiary.account != null) ? res.beneficiary.account.bank : '';
			BeneficiaryBranchName = (res.beneficiary != null && res.beneficiary.account != null) ?
				res.beneficiary.account.branch : '';
			BeneficiaryAccountNo = (res.beneficiary != null && res.beneficiary.account != null) ?
				res.beneficiary.account.accNum : '';
			BeneficiaryIFSC = (res.beneficiary != null && res.beneficiary.account != null) ?
				res.beneficiary.account.ifsc : '';


			var orderObj = {
				orderId: OrderId,
				orderCreatedOn: OrderCreatedOn,
				senderMobile: SenderMobile,
				beneficiaryBankName: BeneficiaryBankName,
				beneficiaryBranchName: BeneficiaryBranchName,
				beneficiaryAccountNo: BeneficiaryAccountNo,
				beneficiaryIFSC: BeneficiaryIFSC,
				suborderObjList: []

			}

			if (!orderList.includes(orderObj)) {
				orderList.push(orderObj);
			}



			orderList.map(order => {

				if (order.orderId == res.id) {
					var suborderList1 = [];

					if (res.subOrders != null) {
						res.subOrders.map(subOrder => {
							var suborderObj = {

								suborderId: subOrder.id != null ? subOrder.id : '',
								suborderAmount: (subOrder.txnDetails != null && subOrder.txnDetails.amount != null) ?
									subOrder.txnDetails.amount : '',
								suborderStatus: subOrder.status == null ? '' : subOrder.status,
								paymentStatus: subOrder.paymentStatus == null ? '' : subOrder.paymentStatus
							}

							if (!suborderList1.includes(suborderObj)) {
								suborderList1.push(suborderObj);
							}
						})
					}

					order.suborderObjList = suborderList1;


				}
				if (!orderList1.includes(order)) {
					orderList1.push(order);
				}

			})

		})


		// console.log('order List:'+JSON.stringify(orderList1));
		console.log('order List size:' + orderList.length);
		console.log('order List size:' + orderList1.length);

		orderList1.map(order => {

			console.log('order ..' + order.orderId);
			console.log('sub length..' + order.suborderObjList.length);

			order.suborderObjList.map(subOrder => {

				var row = {
					SuborderId: '',
					SuborderAmont: '',
					SuborderStatus: '',
					PaymentStatus: '',
					OrderId: '',
					OrderCreatedOn: '',
					SenderMobile: '',
					BeneficiaryBankName: '',
					BeneficiaryBranchName: '',
					BeneficiaryAccountNo: '',
					BeneficiaryIFSC: ''
				}

				row.OrderId = order.orderId;
				row.OrderCreatedOn = order.orderCreatedOn;
				row.SenderMobile = order.senderMobile;

				row.BeneficiaryBankName = order.beneficiaryBankName;
				row.BeneficiaryBranchName = order.beneficiaryBankName;
				row.BeneficiaryAccountNo = order.beneficiaryAccountNo;
				row.BeneficiaryIFSC = order.beneficiaryIFSC;
				row.SuborderId = subOrder.suborderId;
				row.SuborderAmont = subOrder.suborderAmount;
				row.SuborderStatus = subOrder.suborderStatus;
				row.PaymentStatus = subOrder.paymentStatus;
				if (!rowList.includes(row)) {
					rowList.push(row);
				}

			})


		})


		console.log('rowList::' + JSON.stringify(rowList));


		store.dispatch(setTxnReportingData(rowList));




	}
	componentWillUnmount() {
	}





	statusSelect = (event) => {
		if (event.target.value == 'Select') {
			alert('Please select a  status');

		} else {
			this.setState({
				selectedStatus: event.target.value
			})
		}
	}


	formDateSelect = (event) => {
		console.log(event.target.value);
		this.setState({
			formDate: moment(event.target.value).format("YYYY-MM-DD")
		})
	}


	toDateSelect = (event) => {
		console.log(event.target.value);

		this.setState({
			toDate: moment(event.target.value).format("YYYY-MM-DD")

		})
	}


	resetExportDate = (event) => {
		setTimeout(() => {
			store.dispatch(setTxnReportingData(''));
		}, 200);
	}


	printdiv = (event) => {
		event.preventDefault();



		var divContents = document.getElementById("print").innerHTML;
		var a = window.open('', '', 'height=500, width=500');
		a.document.write('<html>');
		a.document.write('<body>');
		a.document.write(divContents);
		a.document.write('</body></html>');
		a.document.close();
		a.print();
	}

	clearAll = (event) => {
		this.setState({
			formDate: '',
			toDate: '',
			selectedStatus: '',
			activePage:1

		})
		this.loadReset();
	}


	submitFilter = (event) => {
		event.preventDefault();
		this.setState({
			applyFiler: 'true'
		});

		this.setState({
			contentLoading: true
		})

		if (this.state.formDate == '' && this.state.toDate == '') {
			alert('Please enter start date or End date');
		} else {
			if (this.state.formDate == '') {
				alert('Please enter start date');
			}

			if (this.state.toDate == '') {
				alert('Please enter end date');
			}
		}


		if (this.state.formDate != '' && this.state.toDate != '') {

			var pageNo = 1;
			const headers = {
				'Authorization': 'Bearer ' + this.props.token,
				'client-id': this.props.agentInfo.id,
				'role': this.props.clientRole
			}

			this.setState({ activePage: pageNo });
			var url = '/api/v1/dmt/order/history' + '/' + this.props.agentInfo.id + '/' + this.state.formDate + '/' + this.state.toDate + '/0';

			httpClient.get(url, { headers }
			).then((response) => {
				this.setState({
					contentLoading: false
				})



				var txnHistoryFilteredList = [];

				if (response.data.response.msg == 'SUCCESS') {
					console.log('transaction history successresponse....' + response.data.list);
					if (this.state.selectedStatus != '') {
						response.data.list.map(txnResp => {
							if (txnResp.status.toUpperCase() == this.state.selectedStatus.toUpperCase()) {
								txnHistoryFilteredList.push(txnResp);
							} else {
								console.log(txnResp.status);
							}
						})

					}
					console.log('txnHistoryFilteredList...' + JSON.stringify(txnHistoryFilteredList));
					if (this.state.selectedStatus != '') {
						store.dispatch(setTxnHistoryResponse(txnHistoryFilteredList));
						store.dispatch(setTxnHistoryElementNo(txnHistoryFilteredList.length));
						store.dispatch(setTxnHistoryPaginationResponse(txnHistoryFilteredList));
					}
					else {
						store.dispatch(setTxnHistoryResponse(response.data.list));
						store.dispatch(setTxnHistoryElementNo(response.data.totalElements));
						store.dispatch(setTxnHistoryPaginationResponse(response.data.list));
					}


				} else {
					this.errorMessageCall(response.data.response.displayMsg)
					console.log('transaction history failure response....' + response.data);

				}
			}).catch(error => {

				this.setState({
					contentLoading: false
				})
				this.errorMessageCall(error.message)

			});
		}

	}

	moneyTransfer = (event, txn) => {


		event.preventDefault();
		this.setState({
			showSenderVisible: false
		})
		store.dispatch(setSendersListDetails(''));

		var senderDetailsUrl = '/api/v1/dmt/customer/details/' + txn.customer.mobile;
		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}

		httpClient.get(senderDetailsUrl, { headers }
		).then((response) => {
			console.log('selected sender response' + JSON.stringify(response.data));
			console.log(response.data.response.msg);
			if (response.data.response.msg == 'SUCCESS') {

				store.dispatch(selectedSender(response.data));
				store.dispatch(selectedBeneList(response.data.customer.beneficiaries));

				var benefc = {
					name: txn.beneficiary.name,
					bankName: txn.beneficiary.account.bank,
					accountNumber: txn.beneficiary.account.accNum,
					ifscCode: txn.beneficiary.account.ifsc,
					beneId: txn.beneficiary.id,
					beneMobile: txn.beneficiary.account.mobile
				}

				store.dispatch(setBeneMoneyTransfer(benefc));


				var moneytransfer = document.getElementById('moneytransfer');
				moneytransfer.click();

			} else {
				this.errorMessageCall(response.data.response.displayMsg)
				// alert(response.data.response.msg);
			}
		}).catch(error => {

			this.errorMessageCall(error.message);
		});
	}

	errorMessageCall = (error) => {
		this.setState({
			errorMessage: error
		})
	}


	render() {
		var recentTxnLoop = ['test', 'test', 'test', 'test', 'test'];
		return (

			<div>
				<HeaderCommon />
				<Menu />
				<div class="main">


					<div class="right-side">
						<div class="container-fluid">


							<div class="row">
								<div class="col-12">
									<div class="card-b" id="rightdiv">
										<div id="recenttxn">
											<div class="head">
												<h3>Transaction History</h3>
												<Link to='/dmt'>
													<button class="back" type="button">Back</button>
												</Link>
												<Link to='/money-transfer'>
													<button id='moneytransfer' hidden={true}></button>
												</Link>

												{this.props.exportData == '' &&
													<button class="exprt" type="button" onClick={this.txnHistory}>exprt</button>
												}
												{this.props.exportData != '' &&
													<CSVLink
														class="exprt"
														data={this.props.exportData}
														asyncOnClick={true}
														onClick={this.resetExportDate}
													>
														Download
													</CSVLink>
												}

												<div class="dropdown fltr">
													<button type="button" class="filter dropdown-toggle" id="fillist" data-bs-toggle="dropdown" data-bs-auto-close="false" aria-expanded="false">Filter</button>

													<div class="dropdown-menu dropdown-menu-end" aria-labelledby="fillist">
														<form>
															<div class="filters">
																<label for="status">Status:</label>


																<select class="form-select" id="status"
																	aria-label=""
																	onChange={this.statusSelect} required>

																	{this.state.statusList.map(status => (
																		<option value={status.value}
																		>{status.label}</option>
																	))}

																</select>

															</div>

															<div class="filters">
																<label for="select-state">From Date:</label>
																<input type="date" name="" id=""
																	onChange={this.formDateSelect}
																/>
															</div>

															<div class="filters">
																<label for="select-state">To Date:</label>
																<input type="date" name="" id=""
																	onChange={this.toDateSelect} />
															</div>

															<div class="fbtn">
																<button class="dbbtn" type="submit" id="btnClear"
																	onClick={this.submitFilter}>Apply</button>
																<button class="lbbtn" type="reset" id="btnClear" onClick={this.clearAll}>Clear</button>
															</div>
														</form>
													</div>


													<div class="headsearch">
														<div class="input-group">
															<input type="text" class="form-control" onChange={this.enterTxn} placeholder="Search transaction..." />
															<button class="btn search" type="button" id="txnsrch" onClick={this.searchTxn}></button>
														</div>
													</div>
												</div>

											</div>
											<div class="txn-list" id="recntxn">
												{/* {this.props.txnHistoryResponse!='' &&
								<div>test</div>} */}

												{this.state.errorMessage == '' &&
													this.props.txnPaginationResponse != ''
													&& this.props.txnPaginationResponse.length > 0 &&
													this.props.txnPaginationResponse.slice(0, 20).map((txn, index) => (

														<div class="txn-item">

															<div class="txn-head" id={"txnhead" + index}>
																<div class="collapsed" data-bs-toggle="collapse" data-bs-target={"#txn" + index}
																	aria-expanded="false" aria-controls={"txn" + index}>
																	<div class={txn.status == 'SUCCESS' ? "txncard grbg" :
																		txn.status == 'PROCESSING' ? "txncard ylbg" :
																			txn.status == 'FAILED' ? "txncard rdbg" : "txncard ylbg"}>
																		<div class="row">
																			<div class="col-12 col-md-5">
																				<div class="txntype">
																					{(txn.beneficiary != null && txn.beneficiary.account != null && txn.beneficiary.account.bank &&
																						this.props.bankLogoListTxt.includes(txn.beneficiary.account.bank.split(' ').join("-") + ".PNG")) ?
																						<img src={'/bank_images/' + txn.beneficiary.account.bank.toLowerCase().split(' ').join("-") + ".png"} alt="bank" /> :
																						<img src={BankLogo} alt="bank" />
																					}
																					<h5>Money Transfer</h5>
																					<p>{(txn.beneficiary != null && txn.beneficiary.name != null) ?
																						txn.beneficiary.name : 'Unknown'}</p>
																				</div>
																			</div>
																			<div class="col-7 col-md-4">
																				<div class="txnid">
																					<h6>#{txn.id.toUpperCase()}</h6>
																					<p>{moment(txn.createdOn).format('DD-MM-YYYY hh:mm:ss')}</p>
																				</div>
																			</div>
																			<div class="col-5 col-md-3">
																				<div class="txnamt">
																					<h4>₹ {txn.transaction != null && txn.transaction.amount}</h4>
																					{txn.status == 'SUCCESS' &&
																						<p class="success">{txn.status.substring(0, 1).toUpperCase() +
																							txn.status.substring(1, txn.status.length).toLowerCase()}</p>
																					}
																					{txn.status == 'PROCESSING' &&
																						<p class="pending">{txn.status.substring(0, 1).toUpperCase() +
																							txn.status.substring(1, txn.status.length).toLowerCase()}</p>
																					}

																					{txn.status == 'FAILED' &&
																						<p class="failed">{txn.status.substring(0, 1).toUpperCase() +
																							txn.status.substring(1, txn.status.length).toLowerCase()}</p>
																					}

																					{(txn.status == '' || txn.status == undefined || txn.status == null) &&
																						<p class="pending">{txn.status}</p>
																					}

																					{txn.origTxn == null &&
																						<p class="failed">Failed</p>
																					}
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>

															<div id={"txn" + index} class="accordion-collapse collapse" aria-labelledby={"txnhead" + index}
																data-bs-parent="#recntxn">
																<div class="txn-details">
																	<div class="row">
																		<div class="col-12 col-sm-5">
																			<div class="txnid">
																				<h6>Account Nubmer</h6>
																				<p>{(txn.beneficiary != null && txn.beneficiary.account != null &&
																					txn.beneficiary.account.accNum != null) ? txn.beneficiary.account.accNum : 'NA'}</p>
																			</div>
																		</div>
																		<div class="col-6 col-sm-4">
																			<div class="txnid">
																				<h6>IFSC Code</h6>
																				<p>{(txn.beneficiary != null && txn.beneficiary.account != null
																					&& txn.beneficiary.account.ifsc != null) ? txn.beneficiary.account.ifsc : 'NA'}</p>
																			</div>
																		</div>
																		<div class="col-6 col-sm-3">
																			<div class="txnid rtxt">
																				<h6>Sender Details</h6>
																				<p>{(txn.customer != null && txn.customer.name != null) ? txn.customer.name : 'Unknown User'} -
																					{(txn.customer != null && txn.customer.mobile != null) ? txn.customer.mobile : 'Unknown Mobile'}
																				</p>
																			</div>
																		</div>
																	</div>
																</div>
																{(txn.subOrders != null && txn.subOrders != '' && txn.subOrders != undefined) &&
																	<div class="ordertxn">
																		<SubTransactionTxn response={txn.subOrders}
																			createdOn={txn.createdOn} />
																	</div>

																}


																<div class="ordertxn">
																	<div class="row">
																		{(txn.origTxn != null && txn.origTxn != '' && txn.origTxn != undefined) ?
																			<OrderDetails amount={txn.origTxn.amount}
																				surcharge={txn.origTxn.surcharge}
																				totalAmount={parseFloat(txn.origTxn.amount) +
																					parseFloat(txn.origTxn.surcharge)}
																				res={txn.amount} />
																			:
																			<OrderDetails amount={0}
																				surcharge={0}
																				totalAmount={0}
																				res={txn.amount} />
																		}

																		{(txn.finalTxn != null && txn.finalTxn != '' && txn.finalTxn != undefined) ?
																			<TransferDetails amount={txn.finalTxn.amount}
																				surcharge={txn.finalTxn.surcharge}
																				totalAmount={parseFloat(txn.finalTxn.amount) +
																					parseFloat(txn.finalTxn.surcharge)}
																				res={txn.amount} />
																			:
																			<TransferDetails amount={0}
																				surcharge={0}
																				totalAmount={0}
																				res={txn.amount} />
																		}


																	</div>
																</div>

																{txn.origTxn != null &&
																	txn.origTxn.amount != '1.00' &&
																	txn.origTxn.amount != '1' &&
																	<div class="txn-btn">
																		
																		<button type="button" class="retry" onClick={e => this.moneyTransfer(e, txn)}>Repeat</button>
																		{txn.origTxn != null &&
																			<button type="button" class="print"
																				data-bs-toggle="modal"
																				data-bs-target="#print"
																				onClick={e => this.moDalPrint(e, txn)}>Print</button>
																		}
																		{/* <button type="button" class="help" data-toggle="tooltip" title="Help"></button> */}

																	</div>
																}
															</div>
														</div>

													))
												}

												{
													this.state.errorMessage == '' &&
													this.state.contentLoading == false &&
													this.props.txnPaginationResponse.length == 0 &&
													<div >
														No records found
													</div>
												}

												{this.state.errorMessage == '' &&
													this.state.contentLoading == true &&
													// this.props.txnPaginationResponse!='' &&
													recentTxnLoop.map((rctn, index) => (
														<div class="txn-item">
															<div class="txncard">
																<ContentLoader
																	width={350}

																	height={50}
																	speed={1}
																	backgroundColor="#f3f3f3"
																	foregroundColor="#ecebeb"
																	viewBox="0 0 350 50"
																><rect x="48" y="8" rx="3" ry="3" width="100" height="6" />
																	<rect x="48" y="26" rx="3" ry="3" width="40" height="6" />
																	<circle cx="20" cy="20" r="20" />
																</ContentLoader>
															</div>
														</div>
													)
													)
												}



												{this.state.errorMessage != '' &&
													<div class='valid-error'>
														{this.state.errorMessage}
													</div>}


											</div>


											{

												this.state.contentLoading == false &&
												this.props.totalElementsNo > 0 &&
												<div class="pager">

													<p>
														Showing {"Showing " + this.props.txnPaginationResponse != null &&
															this.props.totalElementsNo}  entries</p>
													<Pagination
														activePage={this.state.activePage}
														itemsCountPerPage={20}
														totalItemsCount={
															this.props.txnPaginationResponse != null &&
															this.props.totalElementsNo}
														pageRangeDisplayed={5}
														onChange={this.handlePageChangeDefault.bind(this)}
														className="pagination"
														linkClass="page-link"
														itemClass="page-item"
													/>
												</div>
											}





										</div>
									</div>
								</div>
							</div>
						</div>
					</div>


				</div>



				<FooterComponet />

				{/* {this.state.showModal} */}

				<div class="modal fade" id="print" data-bs-backdrop="static"
					data-bs-keyboard="false" tabindex="-1">
					<div class="modal-dialog">
						<div class="modal-content">
							<div class="modal-header modhead">
								<h5 class="modal-title">Money Transfer Reciept</h5>
								<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
							</div>
							<div class="modal-body">
								<div class="printtable">
									<div class="printlogo">
										<img src={FinxPayLogo} alt="logo" />
									</div>
									<table class="table table-striped table-bordered" border="1" border-collapse>
										<tbody>
											<tr>
												<td>Payment Status:</td>
												<td><strong>{this.state.paymentStatus}</strong></td>
											</tr>

											<tr>
												<td>Benefisciary Name:</td>
												<td>{this.state.beneName}</td>
											</tr>
											<tr>
												<td>Benefisciary Account No:</td>
												<td>{this.state.beneAccount}</td>
											</tr>

											<tr>
												<td>Bank Name:</td>
												<td>{this.state.bankName}</td>
											</tr>

											<tr>
												<td>IFSC Code:</td>
												<td>{this.state.beneifscCode}</td>
											</tr>
											<tr>
												<td>Sender Name:</td>
												<td>{this.state.senderName}</td>
											</tr>

											<tr>
												<td>Transfer Amount:</td>
												<td>₹ {this.state.transferredAmount}</td>
											</tr>
											<tr>
												<td>Surcharge:</td>
												<td>₹ {this.state.surcharge}</td>
											</tr>


											<tr>
												<td>Total Amount:</td>
												<td>₹ {parseFloat(this.state.totalAmount).toFixed(2)}</td>
											</tr>

											<tr>
												<td>Order Id:</td>
												<td>{this.state.orderId}</td>
											</tr>

											<tr>
												<td>Date:</td>
												<td>{this.state.createdOn}</td>
											</tr>

										</tbody>
									</table>

									{this.state.txnSubOrder != '' &&

										<table class="table table-bordered">
											<tbody>
												<tr>
													<td colspan="3">Sub Transactions Details:</td>
												</tr>
												<tr class="table-secondary">
													<td>Transactions ID</td>
													<td>Amount</td>
													<td>Status</td>
													<td>Payment Ref.</td>
												</tr>

												{this.state.txnSubOrder.map(txRsp => (

													<tr>
														<td>{txRsp.id}</td>
														<td>₹ {parseFloat(txRsp.txnDetails.amount).toFixed(2)}</td>
														<td>{txRsp.status == 'INIT' ? 'Pending' : txRsp.status.substring(0, 1).toUpperCase() +
															txRsp.status.substring(1, txRsp.status.length).toLowerCase()}</td>
														<td>
															{txRsp.paymentRefId}
														</td>
													</tr>
												))
												}
											</tbody>
										</table>
									}


								</div>
							</div>
							<div class="modal-footer mdftr">
								<button type="button" class="btn dbbtn" data-bs-dismiss="modal" onClick={this.printdiv}>Print</button>
							</div>
						</div>
					</div>
				</div>



			</div>
		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, agentInfo, token, clientRole, txnHistoryResponse, exportData, totalElementsNo,
			txnPaginationResponse, bankLogoListTxt } }
) => ({
	errorMessage, loginErrorMessage, phone, agentInfo, token, clientRole, txnHistoryResponse, exportData,
	totalElementsNo,
	txnPaginationResponse, bankLogoListTxt
});

export default connect(mapStateToProps, null)(TransactionHistory);
